export default __webpack_public_path__ + "static/media/contract-icon.4948ac8e.svg";